import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import { SET_CURRENTLY_DRAGGING } from "../../Constants/reducerEvents";
export default function DraggableContainer({ id, index, ...props }) {
  const dispatch = useDispatch();
  const mouseDown = () => {
    dispatch({ type: SET_CURRENTLY_DRAGGING, payload: true });
  };
  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(provided) => (
        <div
          onMouseDown={mouseDown}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {props.children}
        </div>
      )}
    </Draggable>
  );
}
